import React,  {useEffect} from "react";
import { BrowserRouter ,  Switch, Route } from "react-router-dom";
import {  useDispatch } from "react-redux";

import { initUser} from "./store/actions/initialization";

import { useSelector } from "react-redux";

import NoMatch from "./components/NoMatch/NoMatch";
// import ProtectedRoute from "./ProtectedRoute";
import Loading from "./components/Loading/Loading";
import loadable from '@loadable/component';
import MenuBar from "./MenuBar";
import "./styleAll.css";
import "./components/UI/LoadingCards.css"
import CustomCursor from "./components/CustomCursor";
import MyHomePage from "./components/MyHomePage";
import LoginT1 from "./components/LoginThemes/LTheme1/LoginT1";
import SignUpT1 from "./components/LoginThemes/LTheme1/SignUpT1";
import ValidateOTPtT1 from "./components/LoginThemes/LTheme1/ValidateOTPT1";
import ResetPasswordT1 from "./components/LoginThemes/LTheme1/ResetPasswordT1";
import ResetPassOTPT1 from "./components/LoginThemes/LTheme1/ResetPassOTPT1";
import LoginWithOTPT1 from "./components/LoginThemes/LTheme1/LoginWithOTPT1";
import { Helmet } from "react-helmet-async";
import AddNewPassWordT1 from "./components/LoginThemes/LTheme1/AddNewPasswordT1";
import CoursesFilter from "./components/Filter/CoursesFilter";
import CoursePageCard from "./components/CoursePageDesign/CoursePageCard";
import PlayerCardV1 from "./components/PlayerPage/PlayerCardV1";
import MockTest from "./components/TestPage/Mocks/MockTest";
import Dashboard from "./components/DashboardPage/pages/Dashboard";
import AppDashboard from "./components/DashboardPage/AppDashboard";
import PlayerPageMain from "./components/PlayerPage/PlayerPageMain";
import HomePageTemp from "./components/HomePageTemp";
import StudentBatchPage from "./components/Batches/StudentBatchPage";
import CourseBatchesMain from "./components/Batches/CourseBatchesMain";
import CatalogPage from "./V2/catalog/pages/CatalogPage";
import ProductDetailPage from "./V2/catalog/pages/ProductDetailPage";
import { AuthProvider } from "./V2/auth/context/AuthContext";
import RegisterPage from "./V2/auth/pages/RegisterPage";
import LoginOtpPage from "./V2/auth/pages/LoginOtpPage";
import VerifyOtpPage from "./V2/auth/pages/VerifyOtpPage";
import ProtectedRoute from "./V2/auth/routes/ProtectedRoute";
import CheckoutPage from "./V2/commerce/pages/CheckoutPage";
import MyLearningPage from "./V2/learning/pages/MyLearningPage";
import CoursePlayerPage from "./V2/learning/pages/CoursePlayerPage";
import LeadsPage from "./components/crm/pages/LeadsPage";
import { Toaster } from "react-hot-toast";
import MediaLibraryPage from "./components/mediaUploader/pages/MediaLibrary.page";
import LoginPage from "./components/crm/Auth/LoginPageNode";
import SignupPageNode from "./components/crm/Auth/SignUpPageNode";
import OtpPage from "./components/crm/Auth/OtpPageNode";
import ForgotPasswordPageNode from "./components/crm/Auth/ForgotPasswordPageNode";
import ResetPasswordPageNode from "./components/crm/Auth/ResetPasswordPageNode";
import ProtectedRouteV2 from "./components/crm/Auth/ProtectedRoute";
let lazyLoad =   <Loading/>;
  ;

  // const Login = loadable(() => import("./components/Login"), {
  //   fallback: lazyLoad  });
  //   const SignUp = loadable(() => import("./components/SignUp"), {
  //     fallback: lazyLoad  });

function App() {
  
 
 
 const dispatch = useDispatch();
 
  
 const loginSignUpPopUp = useSelector((state)=>state?.app?.loginSignUpPopUp);
  
 const pageTitle = "TestPrism";
  
 const pageDescription = "Smart practice platform for aspirants.";
  
 const pageSEO = "SSC GD , Bank Exams , ";
  
// getting data from store.
const data = useSelector((state)=>state?.user?.user);
const liveClassdata = useSelector((state)=>state?.user?.liveClass);
//const user_id = useSelector((state)=>state?.user?.user);

//console.log(data)


useEffect(()=>{
    
  dispatch(initUser(data))

  /* dont put data as dependency as it will produce error with redux-persist.
  user will be initiated again and again and token may change infinitely,
  which will affect login & protect-route mechanism.
  */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch])  


const useFavicon = (url) => {

     
  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']");
    if (!link) {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = url;
      document.head.appendChild(newLink);
    } else {
      link.href = url;
    }
  }, [url]);
};
  const useSEO = (title, description, keywords) => {
    useEffect(() => {
      document.title = title;
  
      const updateMetaTag = (name, content) => {
        let tag = document.querySelector(`meta[name="${name}"]`);
        if (!tag) {
          tag = document.createElement("meta");
          tag.name = name;
          document.head.appendChild(tag);
        }
        tag.content = content;
      };
  
      updateMetaTag("description", description);
      updateMetaTag("keywords", keywords);
    }, [title, description, keywords]);
  };

  {// load title from links component with useeffect  and set title data in redux .
    // get seo data from api and set it here.
    // get fav icon link from  api  
  }
  useSEO(pageTitle, pageDescription, pageSEO);

  useFavicon("https://i.postimg.cc/1XwL6G0L/prism.png"); // Replace with your favicon URL

     return (<div >
   
    <CustomCursor  />
    
    <BrowserRouter><Toaster
    position="top-left"
    gutter={10}
    containerStyle={{
        zIndex: 9999999999
    }}
    toastOptions={{
        duration: 2500,
        style: {
            zIndex: 9999999999
        }
    }}
/>
       {/* <Route
  exact
  path="/login"
  component={LoginPage}
/>

<Route
  exact
  path="/register"
  component={RegisterPage}
/>

<Route
  exact
  path="/login-otp"
  component={LoginOtpPage}
/>

<Route
  exact
  path="/verify-otp"
  component={VerifyOtpPage}
/>

<ProtectedRoute
  exact
  path="/checkout/:productId/:planId"
  component={CheckoutPage}
/>

<Route
   exact
  path="/my-learning"

  component={MyLearningPage}

/>
<Route
   exact
  path="/course-player/:enrollmentId"

  component={CoursePlayerPage}

/> */}
    {/* <MenuBar/> */}
         {/* {liveClassdata||}  
         {data?.currentToken==null?<div >
         {loginSignUpPopUp=="login"?<div style={{position:"fixed",left:"0px",right:"0px",bottom:"0px",top:"0px",zIndex:"99999999"}}><LoginT1/></div>:""}
         {loginSignUpPopUp=="signUp"?<div style={{position:"fixed",left:"0px",right:"0px",bottom:"0px",top:"0px",zIndex:"99999999"}}><SignUpT1/></div>:""}
         {loginSignUpPopUp=="validateOTP"?<div style={{position:"fixed",left:"0px",right:"0px",bottom:"0px",top:"0px",zIndex:"99999999"}}><ValidateOTPtT1/></div>:""}
         {loginSignUpPopUp=="resetPassword"?<div style={{position:"fixed",left:"0px",right:"0px",bottom:"0px",top:"0px",zIndex:"99999999"}}><ResetPasswordT1/></div>:""}
         {loginSignUpPopUp=="resetPassOTP"?<div style={{position:"fixed",left:"0px",right:"0px",bottom:"0px",top:"0px",zIndex:"99999999"}}><ResetPassOTPT1/></div>:""}
         {loginSignUpPopUp=="loginWithOTP"?<div style={{position:"fixed",left:"0px",right:"0px",bottom:"0px",top:"0px",zIndex:"99999999"}}><LoginWithOTPT1/></div>:""}
         {loginSignUpPopUp=="addNewPassword"?<div style={{position:"fixed",left:"0px",right:"0px",bottom:"0px",top:"0px",zIndex:"99999999"}}><AddNewPassWordT1/></div>:""}
         </div>:<></>} */}
         <Switch>
           
{/* 
         <Route

  exact

  path="/catalog"

  component={
    CatalogPage
  }

/>
<Route

  exact

  path="/catalog/products/:productId"

  component={
    ProductDetailPage
  }

/>
        <Route exact path="/"  component={HomePageTemp}/>
        <Route exact path="/filter"  component={CoursesFilter}/>
     
       <Route exact path="/courses"  > <CourseBatchesMain  /></Route>
         <Route  path="/courses/:courseId?/" ><CoursePageCard /></Route> */}
      {/* <Route  path="/player"  component={PlayerPageMain}/> */}
      {/* <Route exact path="/mock"  component={MockTest}/>
      <Route exact path="/dashboard"  component={AppDashboard}/> */}
      
      
      <ProtectedRouteV2 user={{}}  path="/crm"><LeadsPage/></ProtectedRouteV2>
      <Route exact path="/media"  component={MediaLibraryPage}/>
       <Route exact path="/" component={LoginPage}/>
       
           
         <Route path="/signUpV2" component={SignupPageNode}/>
         <Route path="/verify-otpV2" component={OtpPage}/>
        <Route path="/forgot-passwordV2" component={ForgotPasswordPageNode}/>
       <Route path="/reset-passwordV2" component={ResetPasswordPageNode}/>
        
      
      {/* <Route  path="/mock" component={MockPaper}/> */}
    

       
      {/* <ProtectedRoute user={{}}  path="/live"><LiveClass/></ProtectedRoute>
               

      <ProtectedRoute user={{}}  path="/dashboard"><Dashboard/></ProtectedRoute>
     
                 <ProtectedRoute user={{}}  path="/messenger"> </ProtectedRoute>
                 <ProtectedRoute user={{}}  path="/checkout"> </ProtectedRoute>
                 */}
  
                 {/* <Route  path="/course" component={PreviewCoursePopup} /> */}

{/* <Route  path="*"> <NoMatch/>  </Route>     */}
          </Switch>
    </BrowserRouter>
    
    </div>
  );
};
export default App;






